import {
	GET_MEMBERS,
	GET_MEMBERS_SUCCESS,
	GET_MEMBERS_FAILURE,
	SET_INITIAL_MEMBERS,
	INVITE_MEMBER,
} from './types';

export const getMembersAction = (payload: any) => ({
	type: GET_MEMBERS,
	payload,
});

export const getMembersSuccessAction = (payload: any) => ({
	type: GET_MEMBERS_SUCCESS,
	payload,
});

export const getMembersFailureAction = (error: Error) => ({
	type: GET_MEMBERS_FAILURE,
	payload: error,
});

export const setInitialMembesAction = () => ({
	type: SET_INITIAL_MEMBERS,
});

export const inviteMemberAction = (payload: any) => ({
	type: INVITE_MEMBER,
	payload,
});
